<div *ngIf="incomingData.overlay" class="jaspero__confirmation_overlay" [class.active]="animationState === 'enter'" (click)="overlayClick()"></div>
<div class="jaspero__confirmation_dialog" [class.active]="animationState === 'enter'">
  <div class="jaspero__confirmation_dialog-title">
    <jaspero-variable-content [isTemplate]="incomingData.titleIsTemplate" [item]="incomingData.title"></jaspero-variable-content>
  </div>
  <div class="jaspero__confirmation_dialog-content">
    <jaspero-variable-content [isTemplate]="incomingData.messageIsTemplate" [item]="incomingData.message"></jaspero-variable-content>
  </div>
  <div class="jaspero__confirmation_dialog-actions">
    <button class="primary" NoDblClick (click)="resolve({resolved: true})">
      <jaspero-variable-content [isTemplate]="incomingData.confirmTextIsTemplate" [item]="incomingData.confirmText"></jaspero-variable-content>
    </button>
    <button class="default" (click)="resolve({resolved: false})" #focus>
      <jaspero-variable-content [isTemplate]="incomingData.declineTextIsTemplate" [item]="incomingData.declineText"></jaspero-variable-content>
    </button>
  </div>
</div>



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/ng-confirmations/components/confirmation/confirmation.component.html